module.exports = __webpack_public_path__ + "img/turn-left.ec65556b.png";